import AsyncLoader from 'component/AsyncLoader';

export const AccountBalance =  AsyncLoader(() => import('./AccountBalance'));
export const RechargeEntry =  AsyncLoader(() => import('./RechargeEntry'));
export const RechargeRecord =  AsyncLoader(() => import('./RechargeRecord'));